import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

import {Skills} from "./components/cards/skill";
import {Senses} from "./components/cards/sns";
import {Status} from "./components/cards/status";

ReactDOM.render(
  <React.StrictMode>
    <App/>
    <div className="mx-5 max-w-6xl md:flex">
      <div className="text-center md:text-left">
        <img
          src="https://avatars.githubusercontent.com/u/52205108?s=400&u=586d0c24847b3ef9e97f1afeeee7ee8d1f647881&v=4"
          alt="Kai's avatar"
          className="w-24 rounded-full my-3 mx-auto md:mx-0"
        />
        <h1>Kai</h1>
        <ul className="text-base text-purple-500 font-mono mt-3">
          <li>Student</li>
          <li>Web Backend Engineer</li>
          <li>Internship</li>
          <li>Vice President of school council</li>
        </ul>
        {/* SNS Links */}
        <Senses/>
      </div>

      <div>
        <div className="mb-5">
          <h2>About Me</h2>
          <p className="text-base ml-3">
            I am a high school student interning as a backend engineer and also like personal development and aim to
            become a web full stack engineer.
          </p>
        </div>

        <Skills/>

        <Status />
      </div>
    </div>

  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
